import { Fragment, Slice } from 'prosemirror-model';
import { Plugin } from 'prosemirror-state';
import { dropPoint } from 'prosemirror-transform';
import { imageType } from '../../../../extensions/markdown';
import { fileType } from '../../../../extensions/yfm/YfmFile';
import { isFunction } from '../../../../lodash';
import { clipboardUtils } from '../../Clipboard';
import { createImageNode } from '../../ImgSizeAdditions/utils'; // TODO: remove hard import
import { YfmFilesUploadProcessBase } from './upload';
const { isFilesOnly, isFilesFromHtml, isImageFile } = clipboardUtils;
export const YfmFilePaste = (builder, opts) => {
    if (!opts || !isFunction(opts.fileUploadHandler))
        throw new Error('YfmFilePaste extension: fileUploadHandler is not a function');
    builder.addPlugin(() => new Plugin({
        props: {
            handleDOMEvents: {
                paste(view, e) {
                    const files = getPastedFiles(e.clipboardData);
                    if (files) {
                        e.preventDefault();
                        new YfmFilesPasteUploadProcess(view, files, {
                            uploadHandler: opts.fileUploadHandler,
                            needToSetDimensionsForUploadedImages: opts.needToSetDimensionsForUploadedImages,
                        }).run();
                        return true;
                    }
                    return false;
                },
                drop(view, e) {
                    var _a, _b;
                    // handle drop files from device
                    if (view.dragging)
                        return false;
                    const files = getPastedFiles(e.dataTransfer);
                    if (!files)
                        return false;
                    const dropPos = (_b = (_a = view.posAtCoords({ left: e.clientX, top: e.clientY })) === null || _a === void 0 ? void 0 : _a.pos) !== null && _b !== void 0 ? _b : -1;
                    if (dropPos === -1)
                        return false;
                    const posToInsert = dropPoint(view.state.doc, dropPos, createFakeFileSlice(view.state.schema));
                    if (posToInsert !== null) {
                        new YfmFilesPasteUploadProcess(view, files, {
                            pos: posToInsert,
                            uploadHandler: opts.fileUploadHandler,
                            needToSetDimensionsForUploadedImages: opts.needToSetDimensionsForUploadedImages,
                        }).run();
                    }
                    e.preventDefault();
                    return true;
                },
            },
        },
    }), builder.Priority.Low);
};
function getPastedFiles(data) {
    if (!data)
        return null;
    if (!isFilesOnly(data) && !isFilesFromHtml(data))
        return null;
    return Array.from(data.files);
}
function createFakeFileSlice(schema) {
    return new Slice(Fragment.from(fileType(schema).create({
        href: 'fake',
        download: 'file',
    })), 0, 0);
}
class YfmFilesPasteUploadProcess extends YfmFilesUploadProcessBase {
    constructor(view, files, opts) {
        super(view, files, opts.uploadHandler);
        this.pos = opts.pos;
        const { schema } = this.view.state;
        if (imageType(schema)) {
            this.createImage = createImageNode(imageType(schema), {
                needDimmensions: opts.needToSetDimensionsForUploadedImages,
            });
        }
    }
    getSkeletonInitPos() {
        var _a;
        return (_a = this.pos) !== null && _a !== void 0 ? _a : this.view.state.tr.selection.from;
    }
    async createPMNode(res) {
        return isImageFile(res.file) && this.createImage
            ? this.createImage(res)
            : this.createFile(res);
    }
}
